import React from "react";
import Header from "./components/header";
import Hero from "./components/hero";
import About from "./components/about";
import Skills from "./components/skills";
import Projects from "./components/projects";
import Workflow from "./components/workflow";
import Contact from "./components/contact";

function App() {
  return (
    <div className="bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <Header />
      <Hero />
      <Workflow />
      <Skills />
      <About />
      <Projects />
      <Contact />
    </div>
  );
}

export default App;